export * from './data-filter-name.pipe';



// WEBPACK FOOTER //
// /Users/Miroslav/Projects/Dubravica/backoffice/src/app/theme/pipes/dataFilterName/index.ts